import React from 'react'
import injectSheet from 'react-jss'
import moment from 'moment'
import {
  Cancel,
  Pdf,
} from '../../icons/actionIcons'
import { IconButton } from '../../'

const AdminOfferListItem = (props) => {
  const {
    classes,
    deleteOfferMutation,
    offer,
  } = props

  return (
    <div className={`${classes.item}`}>
      <div className={`${classes.content}`}>
        <div className={`${classes.client}`}>
          {offer.client.firstName} {offer.client.lastName}
        </div>
        <div className={`${classes.location}`}>
          {offer.client.location}
        </div>
        <div className={`${classes.email}`}>
          {offer.client.email}
        </div>
        <div className={`${classes.created}`}>
          {moment(offer.createdAt).format('DD.MM.YYYY')}
        </div>
        <div className={`${classes.message}`}>
          {offer.client.message}
        </div>
      </div>
      <div className={`${classes.actions}`}>
        <IconButton
          href={`${process.env.REACT_APP_PDF_GENERATOR}${offer.id}`}
          external
          icon={<Pdf />}
          tip="PDF generieren"
        />
        <IconButton
          handleClick={() => {
            deleteOfferMutation({
              variables: { id: offer.id },
            })
          }}
          icon={<Cancel />}
          index={0}
          primary
          modal
          modalText="Wollen Sie dieses Angebot unwiderruflich löschen?"
          modalTitle="Angebot löschen?"
          tip="löschen"
        />
      </div>
    </div>
  )
}

const styles = theme => ({
  item: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    padding: `${theme.sizes.gutter / 2}px`,
    margin: '2px 0',
    backgroundColor: theme.colors.main_2,
    borderWidth: '1px',
    borderColor: theme.colors.main_2,
    borderRadius: '3px',
    borderStyle: 'solid',
    color: theme.colors.main_3,
    transition: [
      {
        property: 'color',
        duration: theme.speed.fast,
      },
      {
        property: 'border-color',
        duration: theme.speed.fast,
      },
    ],
    '&:hover': {
      color: theme.colors.secondary_3b,
      borderColor: theme.colors.main_3,
    },
  },
  content: {
    display: 'flex',
    width: '100%',
    '& > div:not(.actions)': {
      marginRight: `${theme.sizes.gutter / 4}px`,
      overflow: 'hidden',
    },
  },
  client: {
    width: '20%',
  },
  location: {
    width: '15%',
  },
  email: {
    width: '25%',
  },
  created: {
    width: '15%',
  },
  message: {
    width: '25%',
  },
  actions: {
    display: 'flex',
    padding: `0 ${theme.sizes.gutter / 2}px`,
    '& > div': {
      margin: '0 2px',
    },
  },
})


export default injectSheet(styles)(AdminOfferListItem)



// WEBPACK FOOTER //
// ./src/modules/admin/components/adminOfferListItem.jsx